import {
  Component,
  OnInit,
  OnDestroy,
  ViewChild,
  ElementRef,
  AfterViewInit,
} from "@angular/core";
import { environment } from "src/environments/environment";
import { MatDialog } from "@angular/material/dialog";
import { ChangeAddressComponent } from "../modal/change-address/change-address.component";
import { EventService } from "src/app/services/event.service";
import { FormGroup, FormControl, Validators, FormArray } from "@angular/forms";
import { ApiService } from "src/app/services/api.service";
import endpoints from "src/app/helpers/endpoints";
import { Subject } from "rxjs";
import {
  debounceTime,
  distinctUntilChanged,
  retry,
  takeUntil,
} from "rxjs/operators";
import { CommonService } from "src/app/services/common.service";
import { StorageService } from "src/app/services/storage.service";
import { HttpErrorResponse, HttpResponse } from "@angular/common/http";
import { EditPropertyComponent } from "../modal/edit-property/edit-property.component";
// import { CopayFeeTextModalComponent } from './copay-fee-text-modal/copay-fee-text-modal.component';
import * as moment from "moment";
import { UserData, checkoutAddress } from "src/app/models/user-data.models";
import { MapsService } from "src/app/services/maps.service";
import { ErrorType } from "src/app/enums/error-type.enum";
import { SidenavService } from "src/app/layout/sidenav/sidenav.service";
import { CheckoutService } from "../../../services/checkout.service";
import { EditPlanTypeComponent } from "../modal/edit-plan-type/edit-plan-type.component";
import { PaymentMethodsEnum } from "src/app/pages/customer-dashboard/enums/customer-dashboard.enum";
import { ActivatedRoute } from "@angular/router";
import { Location } from '@angular/common';
import { MetaEventService } from "src/app/services/meta-event.service";

@Component({
  selector: "fury-checkout",
  templateUrl: "./checkout.component.html",
  styleUrls: ["./checkout.component.scss"],
})
export class CheckoutComponent implements OnInit, OnDestroy, AfterViewInit {
  steps: number = 1;
  PropertyTypeSizeForm!: FormGroup;
  planForm!: FormGroup;
  cardDetailsForm!: FormGroup;
  customerInfoForm!: FormGroup;
  coverItemsForm!: FormGroup;
  billingInfoForm!: FormGroup;
  escrowDetailsForm!: FormGroup;
  bankDetailsForm!: FormGroup;
  checkForm!: FormGroup;
  waitingPeriodForm!: FormGroup;
  addressInfo!: checkoutAddress;
  installmentForm!: FormGroup;
  loading: boolean = false;
  propertyType: any[] = [];
  propertySize: any[] = [];
  planPrice: any[] = [];
  preservedPlanPrices: any[] = [];
  copayFeeSettings: any[] = [];
  copayFeeSettingsCopy : any[] = [];
  optionalCoverItems: any[] = [];
  selectedOptionalItemsTotalPrice = 0;
  minimunEscrowClosingAmount = 0.01;
  discountedPlanPrice = 0;
  additionalDiscountField = null;
  additionalDiscount = 0;
  totalSavingsPrice = 0;
  processingFeePercentage = 0;
  reflectedAmount = 0;
  selectedPeriodInitial = " for 1 year";
  effectiveTermDate = "";
  effectiveFromDate = "";
  effectiveToDate = "";
  selectedOptionalCoverItems: any[] = [];
  ngUnsubscribe = new Subject<void>();
  expiryYear: number = Number(new Date().getFullYear().toString().slice(2, 4));
  date: any = new Date().toLocaleDateString();
  cardType!: string;
  panelOpenState: boolean = false;
  public PaymentMethods = PaymentMethodsEnum;
  paymentMethod: number = this.PaymentMethods.card;
  isMatchBillingAddress: boolean = false;
  isExcedingMaximumDiscount = false;
  @ViewChild("address", { static: false }) public address!: ElementRef;
  @ViewChild("addressEscrow", { static: false })
  public addressEscrow!: ElementRef;
  selectedPlanPrice: any;
  leadId: string = "";
  agreementNumber!: number | string;
  disableHolderInfoField = true;
  disableAdditionalDiscountField = true;
  optionalPanelOpenState = false;
  copayFeeText: any;
  assetsUrl = environment.assetsUrl + "images/";
  agentId = "";
  maximumAdditionalDiscount = 0;
  today = new Date();
  isOneTimePayment = true;
  installmentLimits: any = {};
  disabledInitialPaymentField = true;
  isCoverageInfo: boolean = false;
  hideCard = false;
  coveredAgreementId = "";
  updateCoverageDetails = null;
  queryParams = null;
  oldPlanPriceId = null;
  refundToDefaultCard = false;
  userId = "";
  showTransactionNumber = false;
  showBankTransactionNumber = false;
  salesTax = 0;
  isSuperAdmin = false;
  customPriceForm!: FormGroup;
  freeMonthMap: Record<string, keyof any> = {
      'PAY MONTHLY': 'monthlyFreeMonth',
      'PAY ANNUALLY': 'annuallyFreeMonth',
      'displayTwoYearlyPrice': 'twoYearsFreeMonth',
      'displayThreeYearlyPrice': 'threeYearsFreeMonth',
      'displayFourYearlyPrice': 'fourYearsFreeMonth',
      'displayFiveYearlyPrice': 'fiveYearsFreeMonth'
    };
  isRenewAgreement: boolean = false;
  constructor(
    public dialog: MatDialog,
    public eventService: EventService,
    public apiService: ApiService,
    public commonService: CommonService,
    private mapService: MapsService,
    private sideNavService: SidenavService,
    public checkoutService: CheckoutService,
    private activatedRoute: ActivatedRoute,
    public location: Location,
    private metaEventService: MetaEventService
  ) {}

  ngOnInit(): void {
    this.queryParams = this.activatedRoute.snapshot.queryParams;
    this.isCoverageInfo = !!this.queryParams?.coverageInfo;
    this.isRenewAgreement = !!this.queryParams?.renewAgreement;
    this.coveredAgreementId = this.queryParams?.ai || null;
    this.userId = this.activatedRoute.snapshot.params["id"] || "";
    this.eventService.checkoutAddress
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((res: checkoutAddress) => {
        if (res) {
          this.addressInfo = res;

          this.oldPlanPriceId = this.isCoverageInfo ? res.planPriceId : null;
          this.leadId = res?.leadId || "";
          if (this.isCoverageInfo) {
            this.hideCard = this.addressInfo.paymentMethod === "escrow-invoice";
            if (this.hideCard) {
              this.paymentMethod = this.PaymentMethods.bank;
            }
          }
          if (this.addressInfo.planSizeId && this.addressInfo.planTypeId)
            this.getPlanPrice();
          this.getSurChargeByState(res.state);
        }
      });

    this.eventService.userData
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((res: UserData) => {
        if (res?.userId) {
          this.agentId = res.userId;
          this.isSuperAdmin = res.isSuperAdmin;
        }
      });
    setTimeout(() => {
      this.sideNavService.close();
    }, 0);

    this.getCopayFeeSettings();
    this.getPropertyType();
    this.getPropertySize();
    this.getInstallmentLimits();
    // this.getCopayFeeText();

    this.formInit();
     if(this.isCoverageInfo && this.isRenewAgreement) {
        this.patchPlanType();
      }
    if (this.addressInfo) {
      this.formatedBillingAddress();
      this.isMatchBillingAddress = true;
    }
    this.cardDetailsForm
      .get("monthYear")
      ?.valueChanges.pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((res: string) => {
        if (res && res.length === 4) {
          this.cardDetailsForm.patchValue({
            expiryMonth: res.substring(0, 2),
            expiryYear: res.substring(2, 4),
          });
        }
      });
    this.escrowDetailsForm
      .get("monthYear")
      ?.valueChanges.pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((res: string) => {
        if (res && res.length === 4) {
          this.escrowDetailsForm.patchValue({
            expiryMonth: res.substring(0, 2),
            expiryYear: res.substring(2, 4),
          });
        }
      });
      this.isCustomPriceValueChanges();
  }

  updateAgreementCoverage(finalStep = 0) {
    if (!this.isCoverageInfo) return;
    const payload = this.createUpdateAgreementPayload(finalStep);
   
    this.apiService
      .patch(
        endpoints.customerDashboard.updateAgreementCoverage(
          this.coveredAgreementId,
          finalStep
        ),
        payload
      )
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(
        (res: any) => {
          this.updateCoverageDetails = res?.body || null;
          if (finalStep === 1) {
            this.steps = 4;
              this.agreementNumber = this.updateCoverageDetails?.agreementNumber || null;
            return;
          }
          const refundForEscrow =
            this.addressInfo.paymentMethod === "escrow-invoice" &&
            this.updateCoverageDetails.refundAmount > 0;
          const extraCharge = this.updateCoverageDetails.extraCharge >= 0;
          this.hideCard = refundForEscrow ? refundForEscrow : !extraCharge;
          if (
            this.hideCard &&
            this.paymentMethod === this.PaymentMethods.card
          ) {
            this.paymentMethod = this.PaymentMethods.bank;
          }
          this.agreementNumber =
            this.updateCoverageDetails?.agreementNumber || null;
          this.hideTransactionNumber();
          this.toggleBankTransactionNumber();
          this.refundToDefaultCard = false;
          if (
            this.updateCoverageDetails.extraCharge >= 0 &&
            this.paymentMethod === this.PaymentMethods.check
          ) {
            if (this.addressInfo.paymentMethod === "escrow-invoice") {
              this.paymentMethod = this.PaymentMethods.bank;
              return;
            }
            if (this.addressInfo.paymentMethod !== "escrow-invoice") {
              this.cardDetailsForm.reset();
              this.paymentMethod = this.PaymentMethods.card;
            }
          }

          if (
            finalStep === 0 &&
            this.updateCoverageDetails.refundAmount > 0 &&
            this.addressInfo.paymentMethod !== "escrow-invoice"
          ) {
            this.hideCard = false;
            this.getRefundableType();
            return;
          }
        },
        (err: HttpErrorResponse) => {
          this.apiService.alert(err.message, ErrorType.Error);
          this.loading = false;
        }
      );
  }

  getRefundableType() {
    this.hideTransactionNumber();
    this.apiService
      .get(
        endpoints.customerDashboard.getAgreementRefundableAction(
          this.coveredAgreementId,
          this.updateCoverageDetails.refundAmount
        )
      )
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe({
        next: (res: HttpResponse<any>) => {
          if (res.body) {
            this.paymentMethod =
              this.paymentMethod === this.PaymentMethods.check
                ? this.PaymentMethods.card
                : this.paymentMethod;
            this.refundToDefaultCard =
              res.body?.refundableToOriginalPaymentSource;
            const defaultCard = res.body?.defaultPaymentDetail;

            if (this.refundToDefaultCard) {
              this.cardDetailsForm.patchValue({
                cardHoldarName: defaultCard.cardHolderName,
                cardNumber: defaultCard?.cardNumber,
                cvv: defaultCard?.cvv,
                expiryMonth: defaultCard?.expiryMonth,
                expiryYear: defaultCard?.expiryYear,
                monthYear: `${
                  defaultCard?.expiryMonth
                }${defaultCard?.expiryYear.substring(2, 4)}`,
              });
            } else {
              this.validateTransactionNumber();
            }
            this.toggleBankTransactionNumber();
          }
        },
        error: (err: HttpErrorResponse) => {
          this.apiService.alert(err.message, ErrorType.Error);
        },
      });
  }

  hideTransactionNumber() {
    this.showTransactionNumber = false;
    const transactionNumberControl =
      this.cardDetailsForm.get("transactionNumber");
    transactionNumberControl?.removeValidators(Validators.required);
    transactionNumberControl.updateValueAndValidity();
  }

  toggleBankTransactionNumber() {
    let showTransactionNumber = this.updateCoverageDetails.refundAmount > 0;
    let transactionNumberControl =
      this.bankDetailsForm.get("transactionNumber");

    if (showTransactionNumber && !this.refundToDefaultCard) {
      this.showBankTransactionNumber = true;
      transactionNumberControl.setValidators(Validators.required);
      transactionNumberControl.updateValueAndValidity();
    } else {
      this.showBankTransactionNumber = false;
      transactionNumberControl?.removeValidators(Validators.required);
      transactionNumberControl.updateValueAndValidity();
    }
  }

  validateTransactionNumber() {
    this.showTransactionNumber = this.updateCoverageDetails.refundAmount > 0;
    if (this.showTransactionNumber) {
      const transactionNumberControl =
        this.cardDetailsForm.get("transactionNumber");
      transactionNumberControl.setValidators(Validators.required);
      transactionNumberControl.updateValueAndValidity();
      return;
    }
    this.hideTransactionNumber();
  }

  get isZeroAmount() {
    return (
      this.updateCoverageDetails?.refundAmount === 0 &&
      this.updateCoverageDetails?.extraCharge === 0
    );
  }
  createUpdateAgreementPayload(finalStep: number) {
    const payload: any = {
      isRenew: this.isRenewAgreement,
      isZeroAmount: this.isZeroAmount,
      isEscrowPayment: this.addressInfo.paymentMethod === "escrow-invoice",
      agentId: this.agentId,
      firstName: this.customerInfoForm.value.firstName || "",
      lastName: this.customerInfoForm.value.lastName || "",
      phoneNumber: this.customerInfoForm.value.phone || "",
      emailAddress: this.customerInfoForm.value.email || "",
      address: this.addressInfo?.address,
      unitNumber: this.addressInfo.unitNumber,
      state: this.addressInfo?.state,
      city: this.addressInfo?.city,
      zip: this.addressInfo?.zip,
      mainPlanId: this.planForm.value.planPriceId,
      coveredItem: this.selectedOptionalCoverItems.map(
        (ele) => {
         return { itemId : ele.planCoverItemId, quantity: ele.quantity};
        }),
      pricingOption: this.getPlanType(),
      paymentType:
        this.planForm.value.planType === "PAY MONTHLY"
          ? "Monthly"
          : this.paymentMethod === this.PaymentMethods.escrow
          ? "Full Payment"
          : this.isOneTimePayment
          ? "Full Payment"
          : `${this.installmentForm.value?.installmentType} ${
              this.installmentForm.value?.installmentType > 1
                ? "Payments"
                : "Payment"
            }`,
      isRefundable: this.updateCoverageDetails?.refundAmount > 0,
      isRefundableToMainSource: this.refundToDefaultCard,
      transactionNumber:
        this.paymentMethod === this.PaymentMethods.bank &&
        this.showBankTransactionNumber
          ? this.bankDetailsForm.get("transactionNumber").value
          : this.cardDetailsForm.get("transactionNumber").value,
      copayFee: this.formatPriceInNumber(this.coPayFee, true),
      dayOfMonthlyPayment: this.planForm.get('monthlyPaymentDate').value,

      additionalDiscountedPrice: Number(this.additionalDiscount),
      isCustomPrice: this.steps <= 2 ? false : this.customPriceForm.value?.isCustomPrice,
      freeMonth: this.planForm.value.freeMonth || 0
    };
    if (this.steps > 2 && this.customPriceForm.value?.isCustomPrice) {
      payload.customPrice = this.customPriceForm.value?.customPrice || 0;
    }
    if (finalStep === 0) return payload;

    payload.paymentMethod = this.checkoutService.getSelectedPaymentMethod(
      this.paymentMethod
    );
    payload.billingAddress = {
      streetAddress: this.billingInfoForm.value.address,
      state: this.billingInfoForm.value.state,
      city: this.billingInfoForm.value.city,
      zip: this.billingInfoForm.value.zip,
      unitNumber: this.billingInfoForm.value.unitNumber,
    };

    if (!this.isZeroAmount) {
      if (this.paymentMethod === this.PaymentMethods.card) {
        payload.paymentDetail = {
          cardNumber: this.cardDetailsForm.value.cardNumber,
          expiryYear: this.cardDetailsForm.value.expiryYear
            ? "20" + this.cardDetailsForm.value.expiryYear
            : null,
          expiryMonth: this.cardDetailsForm.value.expiryMonth,
          cvv: this.cardDetailsForm.value.cvv,
        };

        // For Card Installment
        if (
          !this.isOneTimePayment &&
          this.planForm.value.planType !== "PAY MONTHLY"
        ) {
          payload.initialPaidAmount = this.checkInitialAmount() || null;
          payload.initialPaymentDate = moment(
            this.installmentForm.value?.initialPaymentData
          ).format("YYYY-MM-DD");
          if (this.installmentForm.value?.installmentData)
            payload.installmentPaymentDate = moment(
              this.installmentForm.value?.installmentData
            ).format("YYYY-MM-DD");
        }
      } else if (this.paymentMethod === this.PaymentMethods.bank) {
        payload.bankDetail = {
          bankName: this.bankDetailsForm.value.bankName,
          routingNumber: this.bankDetailsForm.value.routingNumber,
          accountNumber: Number(this.bankDetailsForm.value.accountNumber),
          nameOnAccount: this.bankDetailsForm.value.nameOnAccount,
        };
        //For Bank Installment
        if (
          !this.isOneTimePayment &&
          this.planForm.value.planType !== "PAY MONTHLY"
        ) {
          payload.initialPaidAmount = this.checkInitialAmount() || null;
          payload.initialPaymentDate = moment(
            this.installmentForm.value?.initialPaymentData
          ).format("YYYY-MM-DD");
          if (this.installmentForm.value?.installmentData)
            payload.installmentPaymentDate = moment(
              this.installmentForm.value?.installmentData
            ).format("YYYY-MM-DD");
        }
      }
      // check payment
      else if (this.paymentMethod === this.PaymentMethods.check) {
        payload.checkNumber = this.checkForm.value?.checkNumber;
      }
    }
    return payload;
  }

  getPropertyType() {
    this.apiService
      .get(endpoints.customerDashboard.getPropertyType)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((res: any) => {
        this.propertyType = res.body?.planPropertyTypes.data;
        const selectedPropertyType = this.propertyType.find(
          (ele) => ele.planPropertyTypeId === this.addressInfo.planTypeId
        );
        this.PropertyTypeSizeForm.get("propertyType")?.setValue(
          selectedPropertyType?.title || ""
        );
      });
  }

  getPropertySize() {
    this.apiService
      .get(endpoints.customerDashboard.getPropertySize)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((res: any) => {
        this.propertySize = res.body?.planPropertySizes.data;
        const selectedPropertySize = this.propertySize.find(
          (ele) => ele.planPropertySizeId === this.addressInfo.planSizeId
        );

        this.PropertyTypeSizeForm.get("propertySize")?.setValue(
          selectedPropertySize?.title || ""
        );
      });
  }

  // getCopayFeeText() {
  //   this.apiService
  //     .get(endpoints.checkOut.getCopayFeeText)
  //     .pipe(takeUntil(this.ngUnsubscribe))
  //     .subscribe((res: any) => {
  //       if (res?.copayFeeText) {
  //         this.copayFeeText = res.copayFeeText?.text;
  //       }
  //     });
  // }
  get showEscrowCard() {
    const showEscrowCardSection =
      Number(this.escrowDetailsForm.get("closingAmount")?.value) > 0 &&
      Number(this.escrowDetailsForm.get("closingAmount")?.value) <
      (this.customPriceForm.get('isCustomPrice')?.value ? (Number(this.customPriceForm.get('customPrice')?.value) || 0) : Number(this.subTotalPrice)) &&
      this.paymentMethod === this.PaymentMethods.escrow;
    return showEscrowCardSection;
  }

  get escrowTotalCharged() {
    return (
     this.customPriceForm.get('isCustomPrice')?.value ? (Number(this.customPriceForm.get('customPrice')?.value) - Number(this.escrowDetailsForm.get("closingAmount")?.value) || 0) :  (Number(this.subTotalWithDiscounts) -
        Number(this.escrowDetailsForm.get("closingAmount")?.value)) || 0
    );
  }
  handleClosingAmountChange() {
    if (
      this.showEscrowCard &&
      this.paymentMethod === this.PaymentMethods.escrow
    ) {
      this.setEscrowCardValidation(true);
    } else {
      this.setEscrowCardValidation(false);
    }
  }
  setEscrowCardValidation(isRequired: boolean) {
    if (isRequired) {
      this.escrowDetailsForm
        .get("nameOnCard")
        ?.setValidators([Validators.minLength(2), Validators.required]);
      this.escrowDetailsForm
        .get("cardNumber")
        ?.setValidators(Validators.required);
      this.escrowDetailsForm
        .get("monthYear")
        ?.setValidators(Validators.required);
      this.escrowDetailsForm
        .get("expiryMonth")
        ?.setValidators([
          Validators.required,
          Validators.max(12),
          Validators.min(1),
        ]);
      this.escrowDetailsForm
        .get("expiryYear")
        ?.setValidators([Validators.required, Validators.min(this.expiryYear)]);
      this.escrowDetailsForm.get("cvv")?.setValidators(Validators.required);

      this.escrowDetailsForm.get("nameOnCard")?.updateValueAndValidity();
      this.escrowDetailsForm.get("cardNumber")?.updateValueAndValidity();
      this.escrowDetailsForm.get("monthYear")?.updateValueAndValidity();
      this.escrowDetailsForm.get("expiryMonth")?.updateValueAndValidity();
      this.escrowDetailsForm.get("expiryYear")?.updateValueAndValidity();
      this.escrowDetailsForm.get("cvv")?.updateValueAndValidity();
    } else {
      this.escrowDetailsForm.get("nameOnCard")?.clearValidators();
      this.escrowDetailsForm.get("cardNumber")?.clearValidators();
      this.escrowDetailsForm.get("monthYear")?.clearValidators();
      this.escrowDetailsForm.get("expiryMonth")?.clearValidators();
      this.escrowDetailsForm.get("expiryYear")?.clearValidators();
      this.escrowDetailsForm.get("cvv")?.removeValidators(Validators.required);

      this.escrowDetailsForm.get("nameOnCard")?.updateValueAndValidity();
      this.escrowDetailsForm.get("cardNumber")?.updateValueAndValidity();
      this.escrowDetailsForm.get("monthYear")?.updateValueAndValidity();
      this.escrowDetailsForm.get("expiryMonth")?.updateValueAndValidity();
      this.escrowDetailsForm.get("expiryYear")?.updateValueAndValidity();
      this.escrowDetailsForm.get("cvv")?.updateValueAndValidity();
    }
  }
  handleAdditionDiscountChange(mode) {
    this.maximumAdditionalDiscount = Number(
      this.checkoutService.getMaximumDiscount(
        this.planForm,
        this.selectedPlanPrice
      )
    );

    if (!this.disableAdditionalDiscountField) {
      if (this.additionalDiscountField > this.maximumAdditionalDiscount) {
        this.isExcedingMaximumDiscount = true;
        this.disableAdditionalDiscountField = false;
        return;
      }
      this.isExcedingMaximumDiscount = false;
      this.additionalDiscount = this.additionalDiscountField;
    }

    if (this.paymentMethod === this.PaymentMethods.escrow) {
      this.setClosingAmountValidator();

      this.escrowDetailsForm.controls["closingAmount"].setErrors({ max: null });
      this.escrowDetailsForm.controls["closingAmount"].updateValueAndValidity();
    }
    this.disableAdditionalDiscountField = !this.disableAdditionalDiscountField;
    if (mode === "save") {
      this.updateAgreementCoverage();
    }
  }

  togglePayment(ispaymentMethod: number) {
    this.paymentMethod = ispaymentMethod;
    if (this.paymentMethod === this.PaymentMethods.escrow) {
      this.setClosingAmountValidator();
      this.escrowDetailsForm.get("closingAmount")?.setValue(null);
      this.escrowDetailsForm.get("closingAmount")?.updateValueAndValidity();
      this.setEscrowCardValidation(this.showEscrowCard);
      return;
    }
    this.escrowDetailsForm.get("closingAmount")?.clearValidators();
    this.escrowDetailsForm.get("closingAmount")?.updateValueAndValidity();
  }
  toggleShowFrontPanel(planPriceId: string) {
    const index = this.planPrice.findIndex(
      (item) => item.planPriceId === planPriceId
    );
    if (index !== -1) {
      this.planPrice[index].showFrontPanel =
        !this.planPrice[index].showFrontPanel;
    }
    this.planPrice.forEach((item, i) => {
      if (i !== index) {
        item.showFrontPanel = true;
      }
    });
  }
  openChangePropertyModal() {
    let dialogRef: any;
    if (!(window as any).matchMedia("(min-width: 991px)").matches) {
      dialogRef = this.dialog.open(EditPropertyComponent, {
        autoFocus: false,
        maxWidth: "100vw",
        panelClass: "quotecomponent",
        data: {
          propertySizeArray: this.propertySize,
          propertyTypeArray: this.propertyType,
          selectedPropertySize: this.PropertyTypeSizeForm.value.propertySize,
          selectedPropertyType: this.PropertyTypeSizeForm.value.propertyType,
        },
      });
    } else {
      dialogRef = this.dialog.open(EditPropertyComponent, {
        autoFocus: false,
        data: {
          propertySizeArray: this.propertySize,
          propertyTypeArray: this.propertyType,
          selectedPropertySize: this.PropertyTypeSizeForm.value.propertySize,
          selectedPropertyType: this.PropertyTypeSizeForm.value.propertyType,
        },
      });
    }
    dialogRef
      .afterClosed()
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((result: any) => {
        if (result) {
          this.PropertyTypeSizeForm.get("propertySize")?.setValue(
            result.selectedPropertySize || ""
          );
          this.PropertyTypeSizeForm.get("propertyType")?.setValue(
            result.selectedPropertyType || ""
          );

          const selectedPropertySize = this.propertySize.find(
            (ele) => ele.title === result.selectedPropertySize
          );
          const selectedPropertyType = this.propertyType.find(
            (ele) => ele.title === result.selectedPropertyType
          );

          this.addressInfo = {
            ...this.addressInfo,
            planSizeId: selectedPropertySize.planPropertySizeId,
            planTypeId: selectedPropertyType?.planPropertyTypeId || "",
          };
          this.planForm.get("planPriceId")?.setValue("");
          this.selectedPlanPrice = {};
          this.planForm.markAsUntouched();
          this.getPlanPrice();
        }
      });
  }
  openChangeAddressModal(modalAddres: checkoutAddress): void {
    (window as any).scroll(0, 0);
    let dialogRef: any;
    let modalData = {
      ...modalAddres,
      address: this.removeUnitNumber(modalAddres),
    };
    if (!(window as any).matchMedia("(min-width: 991px)").matches) {
      dialogRef = this.dialog.open(ChangeAddressComponent, {
        autoFocus: false,
        maxWidth: "100vw",
        panelClass: "quotecomponent",
        data: modalData,
      });
    } else {
      dialogRef = this.dialog.open(ChangeAddressComponent, {
        autoFocus: false,
        data: modalData,
      });
    }
    dialogRef
      .afterClosed()
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((result: any) => {
        if (result) {
          this.addressInfo.address = result.address;
          this.addressInfo.city = result.city;
          this.addressInfo.state = result.state;
          this.addressInfo.zip = result.zip;
          this.addressInfo.unitNumber = result.unitNumber;
          this.getSurChargeByState(result.state);

          // updating Billing Address
          if (this.isMatchBillingAddress) this.formatedBillingAddress();
        }
      });
  }

  openCoverageTernModal(data: FormGroup): void {
    let dialogRef: any;
    if (!(window as any).matchMedia("(min-width: 991px)").matches) {
      dialogRef = this.dialog.open(EditPlanTypeComponent, {
        autoFocus: false,
        maxWidth: "100vw",
        panelClass: "quotecomponent",
        data: data,
      });
    } else {
      dialogRef = this.dialog.open(EditPlanTypeComponent, {
        autoFocus: false,
        data: data,
      });
    }
    dialogRef
      .afterClosed()
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((result: string) => {
        if (result) {
          if (result === "PAY MONTHLY" || result === "PAY ANNUALLY") {
            this.planForm.get("planType").setValue(result);
          } else {
            this.planForm.get("planType").setValue("PAY FOR 3 YEARS");
            this.planForm.get("signaturePlan").setValue(result);
          }
          this.onPlanChange({ target:{ value: result } });
        }
      });
  }

  // openCopayFeeModal(data: any) {
  //   (window as any).scroll(0, 0);
  //   if (!(window as any).matchMedia('(min-width: 991px)').matches) {
  //     this.dialog.open(CopayFeeTextModalComponent, {
  //       autoFocus: false,
  //       maxWidth: '100vw',
  //       panelClass: 'quotecomponent',
  //       data: this.copayFeeText,
  //     });
  //   } else {
  //     this.dialog.open(CopayFeeTextModalComponent, {
  //       autoFocus: false,
  //       data: this.copayFeeText,
  //     });
  //   }
  // }

  formInit() {
    this.PropertyTypeSizeForm = new FormGroup({
      propertyType: new FormControl("", [Validators.required]),
      propertySize: new FormControl("", [Validators.required]),
    });
    this.planForm = new FormGroup({
      planType: new FormControl("PAY MONTHLY", [Validators.required]),
      freeMonth: new FormControl('0'),
      planPriceId: new FormControl("", [Validators.required]),
      copyFee: new FormControl(""),
      signaturePlan: new FormControl("displayThreeYearlyPrice"),
      monthlyPaymentDate: new FormControl(new Date().getDate(), [Validators.required]),
    });
    this.customerInfoForm = new FormGroup({
      firstName: new FormControl(this.addressInfo.firstName || "", [
        Validators.required,
        Validators.minLength(2),
      ]),
      lastName: new FormControl(this.addressInfo.lastName || "", [
        Validators.required,
        Validators.minLength(2),
      ]),
      email: new FormControl(this.addressInfo.email || "", [
        Validators.required,
        Validators.pattern(/^[\w.-]+@[\w.-]+\.\w{2,3}$/),
      ]),
      phone: new FormControl(this.addressInfo.phone || "", [
        Validators.required,
        Validators.pattern(/^[2-9][0-8]\d{1}[2-9]\d{2}\d{4}$/),
      ]),
    });
    this.cardDetailsForm = new FormGroup({
      nameOnCard: new FormControl(
        this.addressInfo.firstName && this.addressInfo.lastName
          ? `${this.addressInfo.firstName} ${this.addressInfo.lastName}`
          : "",
        [Validators.required, Validators.minLength(2)]
      ),
      cardNumber: new FormControl("", [Validators.required]),
      monthYear: new FormControl("", [Validators.required]),
      transactionNumber: new FormControl(null),
      expiryMonth: new FormControl("", [
        Validators.required,
        Validators.max(12),
        Validators.min(1),
      ]),
      expiryYear: new FormControl("", [
        Validators.required,
        Validators.min(this.expiryYear),
      ]),
      cvv: new FormControl("", [Validators.required]),
    });
    this.checkForm = new FormGroup({
      checkNumber: new FormControl("", [
        Validators.required,
        Validators.minLength(4),
      ]),
    });
    this.coverItemsForm = new FormGroup({
      planCoverItemIds: new FormArray([]),
    });
    this.billingInfoForm = new FormGroup({
      address: new FormControl("", [Validators.required]),
      state: new FormControl("", [Validators.required]),
      city: new FormControl("", [Validators.required]),
      zip: new FormControl("", [Validators.required]),
      unitNumber: new FormControl(""),
    });
    this.escrowDetailsForm = new FormGroup({
      realtorName: new FormControl("", [Validators.minLength(2)]),
      closingAmount: new FormControl(0),
      realtorEmail: new FormControl("", [
        Validators.pattern(/^[\w.-]+@[\w.-]+\.\w{2,3}$/),
      ]),
      companyName: new FormControl("", [Validators.minLength(2)]),
      companyEmail: new FormControl("", [
        Validators.pattern(/^[\w.-]+@[\w.-]+\.\w{2,3}$/),
      ]),
      closingDate: new FormControl("", [Validators.required]),
      nameOnCard: new FormControl(
        this.addressInfo.firstName && this.addressInfo.lastName
          ? `${this.addressInfo.firstName} ${this.addressInfo.lastName}`
          : "",
        [Validators.minLength(2)]
      ),
      cardNumber: new FormControl(""),
      transactionNumber: new FormControl(null),
      monthYear: new FormControl(""),
      expiryMonth: new FormControl("", [Validators.max(12), Validators.min(1)]),
      expiryYear: new FormControl("", [Validators.min(this.expiryYear)]),
      cvv: new FormControl(""),
    });
    this.waitingPeriodForm = new FormGroup({
      waitingPeriod: new FormControl("30", [
        Validators.required,
        Validators.min(0),
      ]),
    });
    this.installmentForm = new FormGroup({
      installmentType: new FormControl(1),
      initialInstallmentPayment: new FormControl("0", [Validators.min(0)]),
      installmentData: new FormControl(""),
      initialPaymentData: new FormControl(new Date(), [Validators.required]),
    });

    this.bankDetailsForm = new FormGroup({
      routingNumber: new FormControl(null, [
        Validators.required,
        Validators.minLength(9),
        Validators.maxLength(9),
      ]),
      accountNumber: new FormControl(null, [
        Validators.required,
        Validators.minLength(4),
      ]),
      nameOnAccount: new FormControl(
        this.addressInfo.firstName && this.addressInfo.lastName
          ? `${this.addressInfo.firstName} ${this.addressInfo.lastName}`
          : "",
        [Validators.minLength(2)]
      ),
      bankName: new FormControl(""),
      transactionNumber: new FormControl(null),
    });
    this.customPriceForm = new FormGroup({
      isCustomPrice: new FormControl(false),
      customPrice: new FormControl('', [Validators.min(1)]),
    })
  }

  handleCopayValueChange(reflectedAmount: any) {
    this.reflectedAmount = reflectedAmount || 0;
    this.planPrice = this.addCopayToPlan(
      this.preservedPlanPrices,
      reflectedAmount
    );
    const revisedSelectedPlanIndex = this.planPrice.findIndex(
      (ele) => ele.planPriceId === this.selectedPlanPrice?.planPriceId
    );
    if (revisedSelectedPlanIndex > -1) {
      this.selectedPlanPrice = this.planPrice[revisedSelectedPlanIndex];
    }
  }

  getCopayFeeSettings() {
    this.loading = true;
    this.apiService
      .get(endpoints.customerDashboard.checkout.getCopayFeeSettings)
      .subscribe(
        (res: HttpResponse<any>) => {
          if (res.body?.copayFee) {
            this.copayFeeSettings = res.body.copayFee;
            this.copayFeeSettingsCopy = res.body.copayFee;
            this.onPlanChange({ target: { value: this.planForm.value.planType } });
            const defaultCopay = res.body.copayFee.find(
              (ele: { default: any }) => ele.default
            );
            if (this.isRenewAgreement) {
              const renewCopayIndex = res.body.copayFee.findIndex(
                (ele: { amount: any }) => ele.amount === Number(this.addressInfo?.copayFee)
              );
              if (renewCopayIndex > -1) {
                this.reflectedAmount = Number(res.body.copayFee[renewCopayIndex]?.reflectedAmount) || 0;
                const copay = Number(this.addressInfo?.copayFee) || 0;
                this.planForm
                  .get("copyFee")
                  ?.setValue(copay?.toString() || "");
                return;
              }
            }

            if (defaultCopay) {
              this.reflectedAmount = defaultCopay?.reflectedAmount || 0;
              this.planForm
                .get("copyFee")
                ?.setValue(defaultCopay.amount.toString());
              return;
            }
            this.planForm.get("copyFee")?.setValue("");
            this.reflectedAmount = 0;
          } else {
            this.copayFeeSettings = [];
            this.copayFeeSettingsCopy
          }
        },
        () => {
          this.loading = false;
        },
        () => {
          this.getPlanPrice();
        }
      );
  }

  addCopayToPlan(planPrices: any[], copayAmount: any) {
    return planPrices.map((item: any) => {
      return {
        ...item,
        discountedMonthlyPrice:
          Number(item.discountedMonthlyPrice) + Number(copayAmount || 0) / 12,
        discountedThreeYearlyPrice:
          Number(item.discountedThreeYearlyPrice) +
          Number(copayAmount || 0) * 3,
        discountedTwoYearlyPrice:
          Number(item.discountedTwoYearlyPrice) + Number(copayAmount || 0) * 2,
        discountedFourYearlyPrice:
          Number(item.discountedFourYearlyPrice) + Number(copayAmount || 0) * 4,
        discountedFiveYearlyPrice:
          Number(item.discountedFiveYearlyPrice) + Number(copayAmount || 0) * 5,

        discountedYearlyPrice:
          Number(item.discountedYearlyPrice) + Number(copayAmount || 0),
        // displayMonthlyPrice:
        //   Number(item.displayMonthlyPrice) + Number(copayAmount || 0) / 12,
        // displayThreeYearlyPrice:
        //   Number(item.displayThreeYearlyPrice) + Number(copayAmount || 0) * 3,

        // displayTwoYearlyPrice:
        //   Number(item.displayTwoYearlyPrice) + Number(copayAmount || 0) * 2,
        // displayFourYearlyPrice:
        //   Number(item.displayFourYearlyPrice) + Number(copayAmount || 0) * 4,
        // displayFiveYearlyPrice:
        //   Number(item.displayFiveYearlyPrice) + Number(copayAmount || 0) * 5,

        // displayYearlyPrice:
        //   Number(item.displayYearlyPrice) + Number(copayAmount || 0),
      };
    });
  }

  getBankDetail() {
    if (this.bankDetailsForm.value.routingNumber.length !== 9) {
      this.bankDetailsForm.get("bankName").setValue("");
      return;
    }

    this.apiService
      .get(
        endpoints.customerDashboard.checkout.getBankDetail(
          this.bankDetailsForm.value.routingNumber
        )
      )
      .pipe(debounceTime(1000))
      .pipe(distinctUntilChanged())
      .subscribe(
        (res: any) => {
          if (res?.body?.bankName) {
            this.bankDetailsForm.get("bankName").setValue(res?.body?.bankName);
            return;
          }
          this.bankDetailsForm.get("bankName").setValue("");
        },
        (err) => {
          this.bankDetailsForm.get("bankName").setValue("");
          this.apiService.alert(err.error.message, ErrorType.Error);
        }
      );
  }
  getPlanPrice() {
    this.loading = true;
    this.apiService
      .get(
        endpoints.customerDashboard.checkout.getPlanPrice(
          this.addressInfo.planTypeId,
          this.addressInfo.planSizeId
        )
      )
      .subscribe(
        (res: any) => {
          if (res.body?.planPrices) {
            this.getFormattedPlanPrice(res.body);
            if(this.isRenewAgreement) this.planForm.get("planPriceId")?.setValue(this.addressInfo?.planPriceId.toString());
            this.preservedPlanPrices = JSON.parse(
              JSON.stringify(this.planPrice)
            );
            this.planPrice = this.addCopayToPlan(
              this.planPrice,
              this.reflectedAmount
            );
            this.loading = false;
            this.steps = 1;
            this.setFreeMonthOnPlanFetch();
          } else {
            this.preservedPlanPrices = [];
            this.apiService.alert(
              "Please select another plan type or plan size",
              "error"
            );
            this.loading = false;
          }
        },
        (err) => {
          this.loading = false;
        }
      );
  }

setFreeMonthOnPlanFetch(): void {
  const { planPriceId, planType, signaturePlan } = this.planForm.value;

  const selectedPlanPrice = this.planPrice.find(
    (item: any) => item.planPriceId === planPriceId
  );

  const key =
    planType === 'PAY MONTHLY' || planType === 'PAY ANNUALLY'
      ? this.freeMonthMap[planType]
      : this.freeMonthMap[signaturePlan];

  const freeMonthValue = selectedPlanPrice?.[key] ?? 0;
  this.planForm.get('freeMonth')?.setValue(this.isRenewAgreement ? (this.addressInfo.freeMonth || 0) : freeMonthValue);
}

  getFormattedPlanPrice(res: { planPrices: any[] }) {
    const isMobileDevice = !(window as any).matchMedia("(min-width: 991px)")
      .matches;
    let eliteCompletePlan = {};

    this.planPrice = res?.planPrices
      .filter(
        (value: { planPriceId: any; plan_optional_item_category?: any }) => {
          const isEliteComplete =
            value.plan_optional_item_category.title.toLowerCase() ===
            "elite complete";
          if (isEliteComplete) {
            this.planForm
              .get("planPriceId")
              ?.setValue(value.planPriceId.toString());
          }
          if (isMobileDevice && isEliteComplete) {
            eliteCompletePlan = { ...value, showFrontPanel: true };
            return false;
          }
          return true;
        }
      )
      .map((item: any) => {
        return { ...item, showFrontPanel: true };
      });

    if (Object.keys(eliteCompletePlan).length)
      this.planPrice.unshift(eliteCompletePlan);
  }

  getOptionalCoverItem() {
    this.loading = true;
    this.selectedOptionalCoverItems = [];
    (this.coverItemsForm.get("planCoverItemIds") as FormArray).clear();
    this.selectedOptionalItemsTotalPrice = 0;
    this.apiService
      .get(endpoints.customerDashboard.checkout.getOptionalCoverItems)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(
        (res: HttpResponse<any>) => {
          if (res) {
            (window as any).scroll(0, 0);
            this.loading = false;
            if ( res?.body?.optionalCoveredItems.length > 0) {
              res?.body.optionalCoveredItems.forEach((ele: any) => (ele.quantity = 0));
              this.optionalCoverItems = JSON.parse(JSON.stringify(res.body.optionalCoveredItems));
              this.optionalPanelOpenState = true;
              this.steps = 2;
          }
        }
      },
        (err) => {
          this.loading = false;
        }
      );
  }

  checkPropertyForm() {
    if (this.PropertyTypeSizeForm.valid) {
      this.getPlanPrice();
    } else {
      this.PropertyTypeSizeForm.markAllAsTouched();
    }
  }
  checkPlanFrom() {
    if (
      (this.planForm.valid && this.waitingPeriodForm.value?.waitingPeriod) ||
      (this.planForm.valid && this.isCoverageInfo)
    ) {
      this.updateAgreementCoverage();
      if (
        this.planForm.value.planPriceId === this.selectedPlanPrice?.planPriceId
      ) {
        this.optionalPanelOpenState = true;
        this.steps = 2;
        (window as any).scroll(0, 0);
        return;
      }
      this.selectedPlanPrice = this.planPrice.find(
        (item: any) => item.planPriceId === this.planForm.value.planPriceId
      );
      this.getOptionalCoverItem();
    } else {
      this.planForm.markAllAsTouched();
      this.waitingPeriodForm.markAllAsTouched();
    }
  }

  getSurChargeByState(state: string) {
    if (!state) return;
    this.apiService
      .get(endpoints.customerDashboard.checkout.getSurChargeByState(state))
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((res: any) => {
        res = res?.body;
        if (res.states) {
          this.processingFeePercentage = Number(res.states?.processingFeePercentage || 0);
          this.salesTax = Number(res.states?.salesTax || 0);
        }   
      });
  }

  getPlanType() {
    if (this.planForm.value.planType === "PAY FOR 3 YEARS") {
      return this.checkoutService.getSignaturePlanPaload(
        this.planForm.value.signaturePlan
      );
    }
    if (this.planForm.value.planType === "PAY ANNUALLY") {
      return "Yearly";
    }
    return "Monthly";
  }
  patchPlanType() {
    if (this.addressInfo.pricingOption === "Monthly") {
      this.planForm.get("planType")?.setValue("PAY MONTHLY");
    } else if (this.addressInfo.pricingOption === "Yearly") {
      this.planForm.get("planType")?.setValue("PAY ANNUALLY");
    } else {
      this.planForm.get("planType")?.setValue("PAY FOR 3 YEARS");
      if (this.addressInfo.pricingOption === "2 Years") {
        this.planForm.get("signaturePlan")?.setValue("displayTwoYearlyPrice");
      } else if (this.addressInfo.pricingOption === "3 Years") {
        this.planForm.get("signaturePlan")?.setValue("displayThreeYearlyPrice");
      } else if (this.addressInfo.pricingOption === "4 Years") {
        this.planForm.get("signaturePlan")?.setValue("displayFourYearlyPrice");
      } else if (this.addressInfo.pricingOption === "5 Years") {
        this.planForm.get("signaturePlan")?.setValue("displayFiveYearlyPrice");
      }
    }
  }

  getFormatterDate(date: string) {
    if (!date.toString().includes("/")) return "";
    const fullDate = date.split("/");
    return [fullDate[2], fullDate[0], fullDate[1]].join("-"); //yyyy-mm-dd format
  }

  checkCardForm() {
    let isZeroAmount = this.isCoverageInfo && this.isZeroAmount;

    const validEscrow = this.checkEscrowCard(isZeroAmount);
    const validCard = this.checkCard(isZeroAmount);
    const validBank = this.checkBank(isZeroAmount);
    const validCheck = this.checkCheckForm(isZeroAmount);
    const validCustomPriceForm = this.customPriceForm.valid;

    if (
      (this.paymentMethod === this.PaymentMethods.card
        ? validCard
        : this.paymentMethod === this.PaymentMethods.bank
        ? validBank
        : this.paymentMethod === this.PaymentMethods.check
        ? validCheck
        : validEscrow) &&
      this.customerInfoForm.valid && validCustomPriceForm
    ) {
      this.loading = true;
      if (!this.isCoverageInfo) {
        this.apiService
          .post(
            endpoints.customerDashboard.checkout.SaveCheckout,
            this.createPayload()
          )
          .pipe(takeUntil(this.ngUnsubscribe))
          .subscribe(
            (res: HttpResponse<any>) => {
              this.optionalPanelOpenState = false;
              (window as any).scroll(0, 0);
              this.steps = 4;
              this.loading = false;
              this.agreementNumber = res.body.agreementNumber;
              this.metaEventService.addMetaLeadScript(this.addressInfo.leadSource, this.addressInfo.resultCode);
            },
            (err: HttpErrorResponse) => {
              this.apiService.alert(err.message, ErrorType.Error);
              this.loading = false;
            }
          );
      } else {
        this.updateAgreementCoverage(1);
      }
    } else {
      this.cardDetailsForm.markAllAsTouched();
      this.escrowDetailsForm.markAllAsTouched();
      this.billingInfoForm.markAllAsTouched();
      this.customerInfoForm.markAllAsTouched();
      this.waitingPeriodForm.markAllAsTouched();
      this.installmentForm.markAllAsTouched();
      this.bankDetailsForm.markAllAsTouched();
      this.checkForm.markAllAsTouched();
      this.customPriceForm.markAllAsTouched();
    }
  }
  checkEscrowCard(isZeroAmount: boolean) {
    let isValid =
      (isZeroAmount ? true : this.escrowDetailsForm.valid) &&
      (this.showEscrowCard ? this.billingInfoForm.valid : true);
    return isValid;
  }
  checkCard(isZeroAmount: boolean) {
    let isValid =
      (isZeroAmount ? true : this.cardDetailsForm.valid) &&
      this.billingInfoForm.valid &&
      this.waitingPeriodForm.value?.waitingPeriod &&
      (isZeroAmount
        ? true
        : !this.isOneTimePayment
        ? this.installmentForm.valid
        : true);
    return isValid;
  }
  checkBank(isZeroAmount: boolean) {
    let isValid =
      (isZeroAmount ? true : this.bankDetailsForm.valid) &&
      this.billingInfoForm.valid &&
      this.waitingPeriodForm.value?.waitingPeriod &&
      isZeroAmount
        ? true
        : !this.isOneTimePayment
        ? this.installmentForm.valid
        : true;
    return isValid;
  }
  checkCheckForm(isZeroAmount: boolean) {
    let isValid =
      (isZeroAmount ? true : this.checkForm.valid) &&
      this.billingInfoForm.valid;
    return isValid;
  }

  formatPriceInNumber(amount: number | string, usedOutsideOfCreatePayload = false) {
    if(!usedOutsideOfCreatePayload && this.customPriceForm.value?.isCustomPrice) {
      return 0;
    }
    return Number((Math.round(Number(amount) * 100) / 100).toFixed(2));
  }

  createPayload() {
    const billingSddressInfo = {
      streetAddress: this.billingInfoForm.value?.address?.split(',')[0],
      state: this.billingInfoForm.value.state,
      city: this.billingInfoForm.value.city,
      zip: this.billingInfoForm.value.zip,
      unitNumber: this.billingInfoForm.value.unitNumber,
    };
    let payload: any = {
      leadId: this.leadId,
      agentId: this.agentId,
      agreementEffectiveDate: this.getFormatterDate(this.effectiveFromDate),
      agreementExpireDate: this.effectiveToDate.length
        ? this.getFormatterDate(this.effectiveToDate)
        : null,
      firstName: this.customerInfoForm.value.firstName || "",
      lastName: this.customerInfoForm.value.lastName || "",
      phoneNumber: this.customerInfoForm.value.phone || "",
      emailAddress: this.customerInfoForm.value.email || "",
      address: this.addressInfo?.address?.split(',')[0],
      unitNumber: this.addressInfo.unitNumber,
      state: this.addressInfo?.state,
      city: this.addressInfo?.city,
      zip: this.addressInfo?.zip,
      mainPlanId: this.planForm.value.planPriceId,
      coveredItem: this.selectedOptionalCoverItems.map(
        (ele) => {
         return { itemId : ele.planCoverItemId, quantity: ele.quantity};
        }
      ),
      pricingOption: this.getPlanType(),
      paymentType:
        this.planForm.value.planType === "PAY MONTHLY"
          ? "Monthly"
          : this.paymentMethod === this.PaymentMethods.escrow
          ? "Full Payment"
          : this.isOneTimePayment
          ? "Full Payment"
          : `${this.installmentForm.value?.installmentType} ${
              this.installmentForm.value?.installmentType > 1
                ? "Payments"
                : "Payment"
            }`,
      agreementPrice: this.formatPriceInNumber(this.discountedPlanPrice) || 0,
      additionalPrice:
        this.formatPriceInNumber(this.selectedOptionalItemsPlanWise) || 0,
      copayFee: this.formatPriceInNumber(this.coPayFee),
      processingFeePercentage: this.formatPriceInNumber(this.processingFeePercentage),
      discountedPrice: this.formatPriceInNumber(this.totalSavingsPrice) || 0,
      totalAmount: this.formatPriceInNumber(this.totalCostPrice),
      monthlyPayment:
        this.planForm.value.planType === "PAY MONTHLY"
          ? this.formatPriceInNumber(this.subTotalWithDiscounts)
          : 0,
      downPaymentAmount: this.formatPriceInNumber(this.subTotalWithDiscounts),
      freeMonth: this.planForm.value.freeMonth || 0,
      dayOfMonthlyPayment: this.planForm.get('monthlyPaymentDate').value,
      paymentMethod: this.checkoutService.getSelectedPaymentMethod(
        this.paymentMethod
      ),
      billingAddress:
        this.paymentMethod !== this.PaymentMethods.escrow
          ? billingSddressInfo
          : this.showEscrowCard
          ? billingSddressInfo
          : {},
      additionalDiscountedPrice: Number(this.additionalDiscount),
      isCustomPrice: this.customPriceForm.value?.isCustomPrice,
    };
    if (this.customPriceForm.value?.isCustomPrice) {
      payload.customPrice = this.customPriceForm.value?.customPrice || 0;
    }
    if (this.paymentMethod === this.PaymentMethods.escrow) {
      payload.invoiceDate = moment(
        this.escrowDetailsForm.value?.closingDate,
        "YYYY-MM-DD"
      ).format("YYYY-MM-DD");
      payload.realtorName = this.escrowDetailsForm.value?.realtorName;
      payload.realtorEmail = this.escrowDetailsForm.value?.realtorEmail;
      payload.companyName = this.escrowDetailsForm.value?.companyName;
      payload.companyEmail = this.escrowDetailsForm.value?.companyEmail;
      payload.cardPaidAmount = this.showEscrowCard
        ? this.formatPriceInNumber(
            this.escrowDetailsForm.value?.closingAmount || 0
          )
        : 0;
      payload.escrowPaidAmount = this.showEscrowCard
        ? this.formatPriceInNumber(
            this.formatPriceInNumber(this.subTotalWithDiscounts) -
              this.formatPriceInNumber(
                this.escrowDetailsForm.value?.closingAmount
              )
          )
        : this.formatPriceInNumber(this.subTotalWithDiscounts);
      if (this.showEscrowCard) {
        payload.paymentDetail = {
          cardNumber: this.escrowDetailsForm.value.cardNumber,
          expiryYear: this.escrowDetailsForm.value.expiryYear
            ? "20" + this.escrowDetailsForm.value.expiryYear
            : null,
          expiryMonth: this.escrowDetailsForm.value.expiryMonth,
          cvv: this.escrowDetailsForm.value.cvv,
        };
        //For Escrow Installment
        if (
          !this.isOneTimePayment &&
          this.planForm.value.planType !== "PAY MONTHLY"
        ) {
          payload.initialPaidAmount = this.checkInitialAmount();
          payload.initialPaymentDate = moment(
            this.installmentForm.value?.initialPaymentData
          ).format("YYYY-MM-DD");
          if (this.installmentForm.value?.installmentData)
            payload.installmentPaymentDate = moment(
              this.installmentForm.value?.installmentData
            ).format("YYYY-MM-DD");
        }
      } else {
        payload.paymentDetail = {};
      }
    } else if (this.paymentMethod === this.PaymentMethods.card) {
      payload.paymentDetail = {
        cardNumber: this.cardDetailsForm.value.cardNumber,
        expiryYear: this.cardDetailsForm.value.expiryYear
          ? "20" + this.cardDetailsForm.value.expiryYear
          : null,
        expiryMonth: this.cardDetailsForm.value.expiryMonth,
        cvv: this.cardDetailsForm.value.cvv,
      };
      payload.waitingPeriod = Number(
        this.waitingPeriodForm.get("waitingPeriod")?.value || 0
      );
      // For Card Installment
      if (
        !this.isOneTimePayment &&
        this.planForm.value.planType !== "PAY MONTHLY"
      ) {
        payload.initialPaidAmount = this.checkInitialAmount();
        payload.initialPaymentDate = moment(
          this.installmentForm.value?.initialPaymentData
        ).format("YYYY-MM-DD");
        if (this.installmentForm.value?.installmentData)
          payload.installmentPaymentDate = moment(
            this.installmentForm.value?.installmentData
          ).format("YYYY-MM-DD");
      }
    } else {
      payload.bankDetail = {
        bankName: this.bankDetailsForm.value.bankName,
        routingNumber: this.bankDetailsForm.value.routingNumber,
        accountNumber: Number(this.bankDetailsForm.value.accountNumber),
        nameOnAccount: this.bankDetailsForm.value.nameOnAccount,
      };
      //For Bank Installment
      if (
        !this.isOneTimePayment &&
        this.planForm.value.planType !== "PAY MONTHLY"
      ) {
        payload.initialPaidAmount = this.checkInitialAmount();
        payload.initialPaymentDate = moment(
          this.installmentForm.value?.initialPaymentData
        ).format("YYYY-MM-DD");
        if (this.installmentForm.value?.installmentData)
          payload.installmentPaymentDate = moment(
            this.installmentForm.value?.installmentData
          ).format("YYYY-MM-DD");
      }
    }
    return payload;
  }
  checkInitialAmount() {
    let paymentType = this.checkoutService.getSelectedPaymentMethod(
      this.paymentMethod
    );
    if (this.installmentForm?.value?.installmentType === 1) {
      if (
        paymentType === "credit-debit-card" ||
        paymentType === "bank-payment"
      ) {
        return Number(this.subTotalWithDiscounts);
      }
      if (paymentType === "escrow-invoice" && this.showEscrowCard) {
        return this.escrowDetailsForm.value?.closingAmount;
      }
    } else {
      return Number(this.installmentForm.value?.initialInstallmentPayment) || 0;
    }
  }
  get processingFee() {
    const processingFee = Number(this.processingFeePercentage) > 0 ? (Number(this.processingFeePercentage) / 100) * this.getAmountWithoutProcessingFee() : 0;
    return (processingFee|| 0).toFixed(2);
  }
  
  get totalCostPrice(): string {
    const displayPrice = Number(this.discountedPlanPrice);
    return (displayPrice + (this.selectedOptionalItemsPlanWise || 0)).toFixed(
      2
    );
  }

  get totalSavings(): string {
    if (this.planForm.value.planType === "PAY MONTHLY") {
      return (
        Number(this.totalSavingsPrice) * 12 + Number(this.additionalDiscount) ||
        0
      ).toFixed(2);
    }
    return (
      Number(this.totalSavingsPrice) + Number(this.additionalDiscount) || 0
    ).toFixed(2);
  }

  get orderButton() {
    if (Number(this.subTotalWithDiscounts) < 0) return false;

    if (this.showEscrowCard) {
      return (
        !(Number(this.escrowTotalCharged) < 0) &&
        !(this.escrowDetailsForm.get("closingAmount")?.value < 0)
      );
    }
    return true;
  }

  get coPayFee(): number {
    return Number(this.planForm.value.copyFee) || 0;
  }

  get subTotalPrice(): string {
    const displayPrice = Number(this.discountedPlanPrice);
    return (
      displayPrice +
      (this.selectedOptionalItemsPlanWise || 0)
    ).toFixed(2);
  }

  get subTotalPriceInNumber() {
    return Number(this.subTotalPrice);
  }

  get subTotalWithDiscounts() {
    const total = this.getAmountWithoutProcessingFee() + Number(this.processingFee);
    return total.toFixed(2);
  }

  getAmountWithoutProcessingFee(){
    return  Number(this.subTotalPrice) - Number(this.additionalDiscount) + Number(this.salesTax);
  }

  get selectedOptionalItemsPlanWise(): number {
    let date =
      this.paymentMethod !== this.PaymentMethods.escrow
        ? new Date()
        : new Date(this.escrowDetailsForm?.value?.closingDate || new Date()); // Current Date or Escrow Closing Date
    if (this.paymentMethod !== this.PaymentMethods.escrow)
      date.setDate(
        date.getDate() + Number(this.waitingPeriodForm.value.waitingPeriod)
      ); // Set now + waiting period as the considering the start of policy only for card

    if (this.planForm.value.planType === "PAY MONTHLY") {
      this.discountedPlanPrice =
        this.selectedPlanPrice?.discountedMonthlyPrice || 0;
      this.totalSavingsPrice =
        this.selectedPlanPrice?.displayMonthlyPrice -
        this.selectedPlanPrice?.discountedMonthlyPrice;
      this.selectedPeriodInitial = " per month";
      date.setMonth(
        date.getMonth() + Number(this.planForm.value.freeMonth || 0)
      );
      this.effectiveFromDate = this.convertDate(date);
      this.effectiveToDate = "";
      this.effectiveTermDate = `${this.convertDate(date)} - On-Going`;
      return this.selectedOptionalItemsTotalPrice / 12;
    }

    if (this.planForm.value.planType === "PAY FOR 3 YEARS") {
      this.discountedPlanPrice =
        this.checkoutService.getSignaturediscountedPrice(
          this.selectedPlanPrice,
          this.planForm
        ) || 0;
      this.totalSavingsPrice =
        this.checkoutService.getSignatureTotalSavingsPrice(
          this.selectedPlanPrice,
          this.planForm
        );
      this.selectedPeriodInitial =
        " for " +
        this.checkoutService.getSignaturePlanYears(
          this.planForm.value.signaturePlan
        );
      this.effectiveFromDate = this.convertDate(date);
      const currentDate = this.convertDate(date);
      date.setMonth(
        date.getMonth() +
          Number(
          this.planForm.value.freeMonth || 0
          )
      );
      date.setDate(date.getDate() - 1);
      const maxDate = date.setFullYear(
        date.getFullYear() +
          this.checkoutService.getSignaturePlanInNumber(
            this.planForm.value.signaturePlan
          )
      );
      this.effectiveToDate = this.convertDate(maxDate);
      this.effectiveTermDate = `${currentDate} - ${this.convertDate(maxDate)}`;
      return (
        this.selectedOptionalItemsTotalPrice *
        this.checkoutService.getSignaturePlanInNumber(
          this.planForm.value.signaturePlan
        )
      );
    }

    this.discountedPlanPrice =
      this.selectedPlanPrice?.discountedYearlyPrice || 0;
    this.totalSavingsPrice =
      this.selectedPlanPrice?.displayYearlyPrice -
      this.selectedPlanPrice?.discountedYearlyPrice;
    this.selectedPeriodInitial = " for 1 year";
    const currentDate = this.convertDate(date);
    this.effectiveFromDate = this.convertDate(date);
    date.setMonth(
      date.getMonth() + Number(this.planForm.value.freeMonth || 0)
    );
    date.setDate(date.getDate() - 1);
    const maxDate = date.setFullYear(date.getFullYear() + 1);
    this.effectiveToDate = this.convertDate(maxDate);
    this.effectiveTermDate = `${currentDate} - ${this.convertDate(maxDate)}`;

    return this.selectedOptionalItemsTotalPrice;
  }

  convertDate(date: Date | number): string {
    const dateFormatted = new Intl.DateTimeFormat("en-US", {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
    }).format(date);
    return dateFormatted;
  }

  calculateOptionalItemValue(
    standardPrice: string,
    showShortForm = false,
    showOnlyTotalCost = false
  ): string {
    if (this.planForm.value.planType === "PAY MONTHLY") {
      const followText = showShortForm ? "/mo" : " per month";
      const returnValue = showOnlyTotalCost
        ? (Number(standardPrice) / 12 || 0).toFixed(2)
        : (Number(standardPrice) / 12 || 0).toFixed(2) + followText;
      return returnValue;
    }
    if (this.planForm.value.planType === "PAY FOR 3 YEARS") {
      return this.checkoutService.getStandardPrice(
        showOnlyTotalCost,
        standardPrice,
        this.planForm
      );
    }
    const followText = showShortForm ? "/year" : " for 1 year";
    const returnValue = showOnlyTotalCost
      ? (Number(standardPrice) || 0).toFixed(2)
      : (Number(standardPrice) || 0).toFixed(2) + followText;
    return returnValue;
  }

  checkSameBillingAddress(e: any) {
    this.isMatchBillingAddress = e.target.checked;
    if (e.target.checked) {
      this.formatedBillingAddress();
    } else {
      this.billingInfoForm.reset();
    }
  }

  handleDeleteOptionalItems(event: any) {
    this.selectedOptionalCoverItems = this.selectedOptionalCoverItems.filter(
      (ele) => ele.planCoverItemId !== event.planCoverItemId
    );
    this.optionalCoverItems = this.optionalCoverItems.map((ele) => {
      if (ele.planCoverItemId === event.planCoverItemId) {
        ele.isChecked = false;
      }
      return ele;
    });
    this.selectedOptionalItemsTotalPrice =
      this.selectedOptionalCoverItems.reduce(
        (ele, { standardPrice }) => ele + Number(standardPrice),
        0
      ) || 0;
    this.escrowDetailsForm
   this.setClosingAmountValidator(true);
    this.escrowDetailsForm.get("closingAmount")?.updateValueAndValidity();
    this.updateAgreementCoverage();
  }

  onCheckboxChange(item:any, index:number) {
    item.isChecked = true;
    this.optionalPanelOpenState = true;
    const planCoverItemIdsControl: FormArray = this.coverItemsForm.get(
      'planCoverItemIds'
    ) as FormArray;
    planCoverItemIdsControl.push(new FormControl(item.value));
    this.selectedOptionalCoverItems.push(item);
    this.selectedOptionalCoverItems = JSON.parse(
      JSON.stringify(this.selectedOptionalCoverItems)
    );
    this.addQuantity(item, index);
  }

  addQuantity(item: any, index: number) {
    item.quantity = item.quantity + 1;
    this.optionalCoverItems[index].quantity = item.quantity;

    this.selectedOptionalCoverItems.forEach((ele: any) => {
      if (item.planCoverItemId === ele.planCoverItemId) {
        ele.quantity = item.quantity;
      }
    });

    this.selectedOptionalCoverItems = JSON.parse(
      JSON.stringify(this.selectedOptionalCoverItems)
    );
        this.selectedOptionalItemsTotalPrice =
        this.selectedOptionalCoverItems.reduce(
          (ele, { standardPrice, quantity }) => ele + Number(standardPrice) * Number(quantity),
          0
        ) || 0;

        this.updateAgreementCoverage();
  }


  removeQuantity(item: any, index: number) {
    item.quantity = item.quantity > 0 ? item.quantity - 1 : 0;
    this.optionalCoverItems[index].quantity = item.quantity;
    if (item.quantity === 0) {
      this.optionalCoverItems[index].isChecked = false;
    }


    this.selectedOptionalCoverItems = this.selectedOptionalCoverItems.filter((ele) => {
      if (item.planCoverItemId === ele.planCoverItemId) {
        ele.quantity = item.quantity;
        if (item.quantity === 0) {
          ele.isChecked = false;
          return false;
        }
      }
      return true;
    });
    this.selectedOptionalCoverItems = JSON.parse(
      JSON.stringify(this.selectedOptionalCoverItems)
    );

    this.selectedOptionalItemsTotalPrice =
      this.selectedOptionalCoverItems.reduce(
        (ele, { standardPrice, quantity }) => ele + Number(standardPrice) * Number(quantity),
        0
      ) || 0;
      this.updateAgreementCoverage();
  }

  getCardType(cardType: string) {
    this.cardType = cardType;
  }
  scrolltoposition() {
    const element = document.querySelector("#scrolltoposition");
    if (element) {
      setTimeout(() => {
        element.scrollIntoView({ block: "center", behavior: "smooth" });
      }, 100);
    }
  }

  handlePlanSelection(item: any) {
    this.planForm.get("planPriceId")?.setValue(item.planPriceId);
  }

  ngAfterViewInit() {
    if (this.address && this.addressEscrow) {
      this.mapService.autoFillLocation(this.address, "billingAddress");
      this.mapService.autoFillLocation(this.addressEscrow, "billingAddress");
    }
    this.mapService.getaddressEvent
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((res: any) => {
        if (res && typeof res === "object" && res.root === "billingAddress") {
          this.billingInfoForm.patchValue(res);
          this.billingInfoForm.get("zip").setValue(res?.zipcode);
        }
      });
  }

  checkZipCode() {
    this.apiService
      .getCityState(this.billingInfoForm.controls["zip"])
      .then((data) => {
        if (data) {
          this.billingInfoForm.patchValue(data);
        } else {
          this.billingInfoForm.controls["zip"].setErrors({ notValid: true });
        }
      });
  }

  handleEditCoverage(): void {
    this.steps = 1;
    this.additionalDiscountField = null;
    this.disableAdditionalDiscountField = true;
    this.isExcedingMaximumDiscount = false;
    this.additionalDiscount = 0;
    this.togglePayment(this.PaymentMethods.card);
  }

  handleSkip() {
    this.steps = 3;
  }

  formattedCardNumber(cardNumber: string): string {
    if (this.cardType === "American Express") {
      return this.formatAmexCardNumber(cardNumber);
    } else {
      return this.formatDefaultCardNumber(cardNumber);
    }
  }

  private formatAmexCardNumber(cardNumber: string): string {
    const lastFourDigits = cardNumber.slice(-4);
    return `**** ****** *${lastFourDigits}`;
  }

  private formatDefaultCardNumber(cardNumber: string): string {
    return cardNumber.replace(
      /(\d{4})\s?(\d{4})\s?(\d{4})\s?(\d{4})/,
      "**** **** **** $4"
    );
  }
  changeEscrowEmailAndSet(formControllName: string) {
    if (formControllName === "realtorEmail") {
      this.escrowDetailsForm.controls["realtorEmail"].patchValue(
        this.escrowDetailsForm.value.realtorEmail.replace(/\s+/g, "")
      );
    }
    if (formControllName === "companyEmail") {
      this.escrowDetailsForm.controls["companyEmail"].patchValue(
        this.escrowDetailsForm.value.companyEmail.replace(/\s+/g, "")
      );
    }
  }

  handleHolderInfoEdit() {
    if (this.customerInfoForm.status === "INVALID") {
      this.customerInfoForm.markAllAsTouched();
      this.disableHolderInfoField = false;
      return;
    }
    this.disableHolderInfoField = !this.disableHolderInfoField;
  }

  get isHolderInfoDisabled() {
    return this.disableHolderInfoField ? true : null;
  }

  get isAdditionalDiscountDisabled() {
    return this.disableAdditionalDiscountField ? true : null;
  }

  get minDate() {
    const currentDate = new Date();
    const sevenDaysAgo = new Date();
    sevenDaysAgo.setDate(currentDate.getDate() - 7);
    return sevenDaysAgo.toISOString().split("T")[0];
  }

  formatAddress(fullAddress: checkoutAddress) {
    if (fullAddress?.address) {
      let address: string = fullAddress.address;
      if (address.includes(`#${fullAddress.unitNumber}`)) {
        return address;
      } else {
        let splitString = address.split(",");
        if (fullAddress.unitNumber)
          splitString.splice(1, 0, " #" + fullAddress.unitNumber);
        return splitString.toString();
      }
    } else {
      return "";
    }
  }

  removeUnitNumber(addressInfo: checkoutAddress) {
    if (addressInfo.address) {
      if (addressInfo.address.includes(`#${addressInfo.unitNumber}`)) {
        return addressInfo.address.replace(`#${addressInfo.unitNumber},`, "");
      } else {
        return addressInfo.address;
      }
    } else {
      return "";
    }
  }

  formatedBillingAddress() {
    const formatedBillingAddress = {
      ...this.addressInfo,
      address: this.formatAddress(this.addressInfo),
    };
    this.billingInfoForm.patchValue(formatedBillingAddress);
  }
  handleGetPaymentType(isOneTimePayment: boolean) {
    this.isOneTimePayment = isOneTimePayment;
  }
  get waitingPeriodDate() {
    let date = new Date();
    date.setDate(
      date.getDate() + Number(this.waitingPeriodForm?.value?.waitingPeriod || 0)
    );
    return date;
  }
  getInstallmentLimits() {
    this.apiService
      .get(endpoints.checkoutSettings.getCheckoutSettings)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((res: HttpResponse<any>) => {
        if (res.body) {
          this.installmentLimits =
            res.body?.checkout_setting?.installmentLimits;
        }
      });
  }
  handleInitialPaymentFieldDisabled(isDisabled: boolean) {
    this.disabledInitialPaymentField = isDisabled;
  }

  handleGoBack(){
    this.location.back();
  }
  onPlanChange(event: any) {
    this.copayFeeSettings = this.copayFeeSettingsCopy;
    const selectedPlan = event.target.value;

    const signaturePlan = this.planForm.value.signaturePlan;

    const planStatusMap: Record<string, keyof any> = {
      'PAY MONTHLY': 'monthly',
      'PAY ANNUALLY': 'yearly',
      'displayTwoYearlyPrice': 'twoYears',
      'displayThreeYearlyPrice': 'threeYears',
      'displayFourYearlyPrice': 'fourYears',
      'displayFiveYearlyPrice': 'fiveYears'
    };

     

    let statusKey = '';
   const selectedPlanPrice = this.planPrice.find(
        (item: any) => item.planPriceId === this.planForm.value.planPriceId
      );
    if (selectedPlan === 'PAY MONTHLY' || selectedPlan === 'PAY ANNUALLY') {
      statusKey = planStatusMap[selectedPlan] as string;
      this.planForm.get('freeMonth')?.setValue(
        selectedPlanPrice?.[this.freeMonthMap[selectedPlan]] || 0);
    } else {
      statusKey = planStatusMap[signaturePlan] as string;
      
        this.planForm.get('freeMonth')?.setValue(
         selectedPlanPrice?.[this.freeMonthMap[signaturePlan]] || 0);
    }
    if (statusKey.length > 0) {
      this.filterAndSetCopay(statusKey);
    }
  }
  private filterAndSetCopay(statusKey: string) {
    const filteredSettings = this.copayFeeSettings.filter((ele: any) => Boolean(ele?.status?.[statusKey]));
    const copayAmountArray = filteredSettings.map((ele: any) => Number(ele?.amount));
    const currentCopay = Number(this.planForm.value.copyFee);

    this.copayFeeSettings = filteredSettings;

    if (!copayAmountArray.includes(currentCopay)) {
      const firstSetting = filteredSettings[0];
      this.planForm.get('copyFee')?.setValue(firstSetting?.amount?.toString() ?? '');
      this.planForm.get('copyFee')?.updateValueAndValidity();
      this.handleCopayValueChange(firstSetting?.reflectedAmount || 0);
    }
  }
  getServiceAgreementPdf() {
    this.apiService
      .get(
        `${endpoints.customerServiceAgreement.getAgreementDetails(this.agreementNumber, 1)}`
      )
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe({
        next: (res: HttpResponse<any>) => {
          if (res.body?.serviceAgreementPdf) {
            window.open(res.body?.serviceAgreementPdf, "_blank");
          } else {
            this.apiService.alert(
              "Service Agreement PDF Not Found",
              ErrorType.Error
            );
          }
        },
        error: (err: HttpErrorResponse) => {
          this.apiService.alert(err.message, ErrorType.Error);
        },
      });
  }

  setClosingAmountValidator(requiredMinValidators = false) {
    const  closingAmount = this.customPriceForm.get('isCustomPrice').value ? (this.customPriceForm.get('customPrice').value || 0)  :  Number(this.subTotalWithDiscounts) - this.minimunEscrowClosingAmount;
    const validators = requiredMinValidators ? [Validators.max(closingAmount), Validators.min(0)] : [Validators.max(closingAmount)]
    this.escrowDetailsForm.get("closingAmount")?.setValidators(validators);
    this.escrowDetailsForm.get("closingAmount").updateValueAndValidity();
  }
  isCustomPriceValueChanges() {
    this.customPriceForm
      .get("isCustomPrice")
      .valueChanges.pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((res: boolean) => {
       this.setClosingAmountValidator();
      });
  }
  ngOnDestroy(): void {
    this.eventService.checkoutAddress.next(null);
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }
}
